var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14293 17.4855L0.714355 19.2855L2.51436 12.857L14.2858 1.14271C14.4188 1.00665 14.5778 0.898533 14.7531 0.824723C14.9285 0.750912 15.1169 0.712891 15.3072 0.712891C15.4975 0.712891 15.6859 0.750912 15.8614 0.824723C16.0366 0.898533 16.1956 1.00665 16.3286 1.14271L18.8572 3.68557C18.9911 3.81837 19.0974 3.97638 19.1699 4.15045C19.2425 4.32454 19.2798 4.51127 19.2798 4.69985C19.2798 4.88844 19.2425 5.07517 19.1699 5.24925C19.0974 5.42334 18.9911 5.58134 18.8572 5.71414L7.14293 17.4855Z",
    stroke: "#FFF5FA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditwhite);
export default __webpack_public_path__ + "static/media/editwhite.915bb063d22fbff58c7195a0ee2ed275.svg";
export { ForwardRef as ReactComponent };